import { render, staticRenderFns } from "./attr-item.vue?vue&type=template&id=65fe1feb&scoped=true"
import script from "./attr-item.vue?vue&type=script&lang=js"
export * from "./attr-item.vue?vue&type=script&lang=js"
import style0 from "./attr-item.vue?vue&type=style&index=0&id=65fe1feb&prod&lang=scss&scoped=true"
import style1 from "./attr-item.vue?vue&type=style&index=1&id=65fe1feb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fe1feb",
  null
  
)

export default component.exports